module.exports = __webpack_public_path__ + "images/kaitori_bonus_lp/step-1-img-pc_62f10f75a68cab4f66e5b5dd0623b1df.png";